import React from 'react'

import { Accordion } from '../../ui/Accordion'

import { CopyLinkButton } from './CopyLinkButton'

interface QuestionItemProps {
  answer: React.ReactNode
  group?: string | string[]
  id: string
  question: string
  defaultOpen?: boolean
}

export const QuestionItem = ({
  answer,
  group,
  id,
  question,
  defaultOpen,
}: QuestionItemProps): React.ReactElement => {
  const anchor = `faq-${id}`

  return (
    <li id={anchor} data-group={Array.isArray(group) ? group.join(' ') : group}>
      <Accordion title={question} defaultOpen={defaultOpen}>
        {answer}
        <CopyLinkButton anchor={anchor} />
      </Accordion>
    </li>
  )
}
